// @ts-nocheck
(() => {
  const root = document.getElementById('AMReturnsRoot');
  const form = document.getElementById('AMReturnsForm');
  const orderList = document.getElementById('AMReturnsOrderList');
  const shell = document.getElementById('AMReturnsShell');
  if (!root) return;

  const config = readJsonScript('AMReturnsConfig', {
    shopifyDomain: '',
    token: '',
    faqUrl: '',
    shippingHash: {},
    chevronIcon: '',
    progressIcons: {
      select: '',
      reasons: '',
      confirmation: '',
    },
    confirmationIcons: {
      packItems: '',
      attachLabel: '',
      sendOut: '',
    },
  });
  const authToken = resolveAuthToken(config);

  const i18n = readJsonScript('AMReturnsI18n', {});

  function confirmationIconUrl(key) {
    const icons = config.confirmationIcons || {};
    return icons[key] || '';
  }

  const state = {
    loadingForm: false,
    formError: '',
    formValidationErrors: [],
    order: null,
    returnReasons: [],
    items: [],
    shellItems: [],
    returnedItems: [],
    step: 1,
    validateStep: false,
    submitLoading: false,
    confirmationPacklistOpen: true,
  };

  const previewMode = getPreviewMode();

  const ENDPOINTS = {
    details: '/apps/returns/api/v1/shopify/orders',
    reasons: '/apps/returns/api/v1/shopify/return_reasons',
    returns: '/apps/returns/api/v1/shopify/returns',
  };

  const RETURN_IMAGE_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,image/jpeg,image/jpg,image/png,image/gif,image/webp';
  const MAX_RETURN_IMAGE_BYTES = 15 * 1024 * 1024;

  if (form) form.addEventListener('submit', onLookupSubmit);
  if (orderList) orderList.addEventListener('click', onOrderListClick);
  root.addEventListener('click', onRootClick);
  root.addEventListener('change', onRootChange);

  if (previewMode) {
    bootPreview(previewMode);
  }

  function t(key, replacement = {}) {
    let message = i18n[key] || key;
    Object.keys(replacement).forEach((replacementKey) => {
      message = message.replace(`{{ ${replacementKey} }}`, replacement[replacementKey]);
      message = message.replace(`{${replacementKey}}`, replacement[replacementKey]);
    });
    return decodeEntities(message);
  }

  function getPreviewMode() {
    try {
      const params = new URLSearchParams(window.location.search);
      return String(params.get('am_returns_preview') || '').trim().toLowerCase();
    } catch (error) {
      return '';
    }
  }

  function bootPreview(mode) {
    state.order = {
      number: 'ADE2103515',
      creationDate: '22. August 2025',
      returnDate: 'August 27, 2025',
      shippingCountryCode: 'DE',
    };
    state.returnReasons = [
      { id: 'preview-reason-1', reason: 'I do not like the scent', consent_required: false },
      { id: 'preview-reason-2', reason: 'I received the wrong product', consent_required: true },
    ];
    state.shellItems = [];
    state.returnedItems = [];
    state.validateStep = false;
    state.submitLoading = false;

    if (mode === 'confirmation') {
      state.items = [
        {
          uuid: 'preview-item-1',
          title: "Santa's Workshop Duftkerze",
          productImage: '',
          selected: true,
          returnReasonId: 'preview-reason-1',
        },
        {
          uuid: 'preview-item-2',
          title: 'Pumpkin Pie Duftkerze',
          productImage: '',
          selected: true,
          returnReasonId: 'preview-reason-1',
        },
      ];
      state.step = 4;
      state.confirmationPacklistOpen = true;
    } else if (mode === 'reasons') {
      state.items = [
        {
          uuid: 'preview-item-1',
          title: '0.3 Eau de Parfum - 50ml',
          productImage: '',
          selected: true,
          returnReasonId: 'preview-reason-2',
          consentImage: '',
          damagedParcel: false,
          returnMethod: '',
          parcelImage: '',
          labelImage: '',
        },
        {
          uuid: 'preview-item-2',
          title: "Santa's Workshop Duftkerze",
          productImage: '',
          selected: true,
          returnReasonId: '',
          consentImage: '',
          damagedParcel: null,
          returnMethod: '',
          parcelImage: '',
          labelImage: '',
        },
      ];
      state.step = 2;
      state.confirmationPacklistOpen = true;
    } else if (mode === 'existing-reasons') {
      state.items = [
        {
          uuid: 'preview-item-1',
          title: '0.3 Eau de Parfum - 50ml',
          productImage: '',
          selected: true,
          returnReasonId: 'preview-reason-2',
          consentImage: '',
          damagedParcel: false,
          returnMethod: '',
          parcelImage: '',
          labelImage: '',
        },
        {
          uuid: 'preview-item-2',
          title: 'Toffee Crunch Duftkerze',
          productImage: '',
          selected: true,
          returnReasonId: '',
          consentImage: '',
          damagedParcel: null,
          returnMethod: '',
          parcelImage: '',
          labelImage: '',
        },
      ];
      state.returnedItems = [
        {
          uuid: 'returned-item-1',
          title: "Santa's Workshop Duftkerze",
          productImage: '',
          returnReasonId: 'preview-reason-1',
        },
      ];
      state.step = 2;
      state.confirmationPacklistOpen = true;
    } else {
      return;
    }

    if (form) form.classList.add('am-returns__hidden');
    if (shell) shell.classList.add('am-returns__hidden');
    render();
  }

  function onOrderListClick(event) {
    const btn = event.target.closest('[data-am-returns-order]');
    if (!btn || state.loadingForm) return;
    const orderName = String(btn.getAttribute('data-order-name') || '').trim();
    const customerEmail = String(btn.getAttribute('data-customer-email') || '').trim();
    if (!orderName || !customerEmail) return;
    void runLookup(orderName, customerEmail);
  }

  function onLookupSubmit(event) {
    event.preventDefault();
    if (!form || state.loadingForm) return;

    const formData = new FormData(form);
    const orderNumber = String(formData.get('shopify_order_name') || '').trim();
    const customerEmail = String(formData.get('customer_email') || '').trim();

    state.formValidationErrors = [];
    state.formError = '';

    if (!customerEmail) state.formValidationErrors.push(t('account.cancellation.email_validation_message_empty'));
    if (customerEmail && !isValidEmail(customerEmail)) {
      state.formValidationErrors.push(t('account.cancellation.email_validation_message_format'));
    }
    if (!orderNumber) state.formValidationErrors.push(t('account.cancellation.order_name_validation_message_empty'));

    if (state.formValidationErrors.length) {
      renderFormErrors();
      return;
    }

    void runLookup(orderNumber, customerEmail);
  }

  function apiErrorText(detailsResponse, details) {
    if (!details || details.errorcode == null) return '';
    const msg =
      details.messages == null
        ? ''
        : Array.isArray(details.messages)
          ? details.messages.map(String).join(' ')
          : String(details.messages);
    if (details.errorcode === 406) return t('customer.returns.form.error_message_406');
    if (details.errorcode === 404) return msg || t('customer.returns.form.error_message_404');
    return msg || t('customer.returns.form.error_message_lookup', { status: detailsResponse.status });
  }

  async function runLookup(orderNumber, customerEmail) {
    if (state.loadingForm) return;

    state.formValidationErrors = [];
    state.formError = '';
    renderFormErrors();

    state.loadingForm = true;
    renderLookupButton();
    setOrderListBusy(true);

    try {
      const orderCandidates = buildOrderCandidates(orderNumber);
      const [detailsResponse, reasonsResponse] = await Promise.all([
        getOrderReturnDetailsWithFallback(orderCandidates, customerEmail),
        getOrderReturnReasons(),
      ]);

      const details = detailsResponse.data;
      const reasons = reasonsResponse.data;

      if (!detailsResponse.ok) {
        state.formError =
          apiErrorText(detailsResponse, details) ||
          t('customer.returns.form.error_message_lookup', { status: detailsResponse.status });
        renderFormErrors();
        return;
      }

      if (details && details.errorcode) {
        state.formError = apiErrorText(detailsResponse, details) || t('customer.returns.form.error_message_404');
        renderFormErrors();
        return;
      }

      const prepared = prepareOrderReturnResponse({
        orderDetails: details,
        returnReasons: normalizeReturnReasons(reasons),
      });

      state.order = prepared.order;
      state.returnReasons = prepared.returnReasons;
      state.items = prepared.items;
      state.shellItems = prepared.shellItems;
      state.returnedItems = prepared.returnedItems;
      state.step = 1;
      state.validateStep = false;

      if (form) form.classList.add('am-returns__hidden');
      if (shell) shell.classList.add('am-returns__hidden');
      render();
    } catch (error) {
      state.formError = t('customer.returns.form.error_message_404');
      renderFormErrors();
    } finally {
      state.loadingForm = false;
      renderLookupButton();
      setOrderListBusy(false);
    }
  }

  function setOrderListBusy(busy) {
    if (!orderList) return;
    orderList.classList.toggle('am-returns__order-list--busy', busy);
    orderList.querySelectorAll('[data-am-returns-order]').forEach((el) => {
      el.disabled = busy;
    });
  }

  function renderLookupButton() {
    if (!form) return;
    const button = form.querySelector('button[type="submit"]');
    if (!button) return;
    button.disabled = state.loadingForm;
    button.textContent = state.loadingForm ? t('customer.returns.loading') : t('customer.returns.actions.start_return');
  }

  function lookupErrorTarget() {
    return document.getElementById('AMReturnsFormErrors') || document.getElementById('AMReturnsListErrors');
  }

  function renderFormErrors() {
    const target = lookupErrorTarget();
    if (!target) return;
    const errors = [...state.formValidationErrors];
    if (state.formError) errors.push(state.formError);
    target.innerHTML = errors.map((err) => `<p>${escapeHtml(err)}</p>`).join('');
  }

  function onRootClick(event) {
    const actionEl = event.target.closest('[data-action]');
    if (!actionEl) return;

    const action = actionEl.getAttribute('data-action');
    if (action === 'next') {
      onNext();
      return;
    }
    if (action === 'back') {
      state.step = Math.max(1, state.step - 1);
      state.validateStep = false;
      render();
      return;
    }
    if (action === 'toggle-select') {
      const uuid = actionEl.getAttribute('data-uuid');
      updateItem(uuid, (item) => ({ selected: !item.selected }));
      return;
    }
    if (action === 'toggle-packlist') {
      state.confirmationPacklistOpen = !state.confirmationPacklistOpen;
      syncConfirmationPacklist();
      return;
    }
    if (action === 'remove-item') {
      const uuid = actionEl.getAttribute('data-uuid');
      updateItem(uuid, () => ({ selected: false }));
      return;
    }
    if (action === 'toggle-shell') {
      const shellId = Number(actionEl.getAttribute('data-shell-id'));
      const block = root.querySelector(`[data-shell-body="${shellId}"]`);
      if (block) block.classList.toggle('am-returns__hidden');
    }
  }

  function onRootChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    const uuid = target.getAttribute('data-uuid');
    if (!uuid) return;

    if (target.matches('[data-field="reason"]')) {
      updateItem(uuid, () => ({ returnReasonId: Number(target.value) }));
      return;
    }

    if (target.matches('[data-field="returnMethod"]')) {
      updateItem(uuid, () => ({ returnMethod: target.value }));
      return;
    }

    if (target.matches('[data-field="damagedParcel"]')) {
      const damaged = target.value === 'yes';
      updateItem(uuid, () =>
        damaged
          ? { damagedParcel: true }
          : {
              damagedParcel: false,
              parcelImage: '',
              labelImage: '',
              parcelImageFileName: '',
              labelImageFileName: '',
              parcelImageError: '',
              labelImageError: '',
            }
      );
      return;
    }

    if (target instanceof HTMLInputElement && target.type === 'file') {
      handleReturnImageInput(target);
    }
  }

  function returnImageFieldErrorKey(field) {
    return `${field}Error`;
  }

  function returnImageFieldFileNameKey(field) {
    return `${field}FileName`;
  }

  function validateReturnImageFile(file) {
    if (!file) return { ok: true };
    if (file.size > MAX_RETURN_IMAGE_BYTES) return { ok: false, key: 'customer.returns.upload.too_large' };
    const mime = String(file.type || '').toLowerCase();
    const allowedMime = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp']);
    const name = String(file.name || '').toLowerCase();
    const dot = name.lastIndexOf('.');
    const ext = dot >= 0 ? name.slice(dot + 1) : '';
    const allowedExt = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp']);
    if (!allowedMime.has(mime) && !allowedExt.has(ext)) {
      return { ok: false, key: 'customer.returns.upload.bad_type' };
    }
    return { ok: true };
  }

  function handleReturnImageInput(input) {
    const uuid = input.getAttribute('data-uuid');
    const field = input.getAttribute('data-field');
    if (!uuid || !field) return;
    if (!['consentImage', 'parcelImage', 'labelImage'].includes(field)) return;

    const errKey = returnImageFieldErrorKey(field);
    const nameKey = returnImageFieldFileNameKey(field);
    const file = input.files && input.files[0];

    if (!file) return;

    const check = validateReturnImageFile(file);
    if (!check.ok) {
      input.value = '';
      updateItem(uuid, () => ({ [field]: '', [errKey]: t(check.key), [nameKey]: '' }));
      return;
    }

    fileToDataUrl(file)
      .then((result) => {
        if (!result || result.length < 32) {
          input.value = '';
          updateItem(uuid, () => ({
            [field]: '',
            [errKey]: t('customer.returns.upload.read_failed'),
            [nameKey]: '',
          }));
          return;
        }
        updateItem(uuid, () => ({ [field]: result, [errKey]: '', [nameKey]: file.name }));
      })
      .catch(() => {
        input.value = '';
        updateItem(uuid, () => ({
          [field]: '',
          [errKey]: t('customer.returns.upload.read_failed'),
          [nameKey]: '',
        }));
      });
  }

  async function onNext() {
    if (state.step === 1) {
      if (!state.items.some((item) => item.selected)) return;
      state.step = 2;
      render();
      return;
    }

    if (state.step === 2) {
      const isValid = validateSelectedItems();
      state.validateStep = !isValid;
      if (!isValid) {
        render();
        return;
      }
      state.step = 3;
      state.validateStep = false;
      render();
      return;
    }

    if (state.step === 3) {
      const isValid = validateSelectedItems();
      state.validateStep = !isValid;
      if (!isValid || !state.order) {
        render();
        return;
      }

      state.submitLoading = true;
      render();
      try {
        await postOrderReturn({
          items: buildSubmitItems(),
          orderId: state.order.id,
          shopId: state.order.shopId,
        });
        state.step = 4;
      } catch (error) {
        state.formError = t('customer.returns.form.error_message_404');
      } finally {
        state.submitLoading = false;
        render();
      }
    }
  }

  function updateItem(uuid, updater) {
    state.items = state.items.map((item) => {
      if (item.uuid !== uuid) return item;
      return { ...item, ...updater(item) };
    });

    if (!state.items.some((item) => item.selected) && state.step > 1) {
      state.step = 1;
      state.validateStep = false;
    }
    render();
  }

  function validateSelectedItems() {
    const selected = state.items.filter((item) => item.selected);
    if (!selected.length) return false;

    return selected.every((item) => {
      if (!item.returnReasonId) return false;
      const reason = findReturnReasonById(item.returnReasonId);
      if (!reason || !isConsentRequiredFlag(reason.consent_required)) return true;

      if (!item.consentImage || !item.returnMethod) return false;
      if (item.damagedParcel) {
        return Boolean(item.parcelImage && item.labelImage);
      }
      return true;
    });
  }

  function buildSubmitItems() {
    return state.items
      .filter((item) => item.selected)
      .map((item) => ({
        id: item.id,
        returnReasonId: item.returnReasonId,
        returnMethod: item.returnMethod,
        consentImage: item.consentImage,
        quantity: 1,
        labelImage: item.labelImage,
        parcelImage: item.parcelImage,
      }))
      .reduce((acc, item) => {
        const requiresConsent = Boolean(item.consentImage);
        const existing = acc.find(
          (entry) => entry.id === item.id && entry.returnReasonId === item.returnReasonId
        );

        if (requiresConsent || !existing) {
          acc.push(item);
          return acc;
        }

        existing.quantity += 1;
        return acc;
      }, []);
  }

  function render() {
    if (!state.order) return;
    const selectedItems = state.items.filter((item) => item.selected);
    const canGoNext =
      state.step === 1 ? selectedItems.length > 0 : state.step === 2 ? validateSelectedItems() : true;
    const returnedItemsIntro = renderReturnedItemsIntro();
    const orderTitleText = escapeHtml(
      t('customer.returns.order_title', {
        order_number: state.order.number,
        date: state.order.creationDate,
      })
    );
    const orderTitleClasses =
      state.returnedItems.length > 0
        ? 'am-returns__order-title'
        : 'am-returns__order-title am-returns__order-title--new';
    const orderTitleHtml = `<p class="${orderTitleClasses}">${orderTitleText}</p>`;
    /** Confirmation step always uses default title styling (no --new). */
    const orderTitleHtmlConfirmation = `<p class="am-returns__order-title">${orderTitleText}</p>`;
    const contentHtml = `
      ${renderExistingReturnSections()}
      ${state.items.length ? renderProgress() : ''}
      ${state.step === 1 ? renderStepSelection() : ''}
      ${state.step === 2 ? renderStepReasons(false) : ''}
      ${state.step === 3 ? renderStepReasons(true) : ''}
      ${state.formError ? `<p class="am-returns__error">${escapeHtml(state.formError)}</p>` : ''}
      ${state.step < 4 && state.items.length
        ? `<div class="am-returns__actions">
            ${state.step > 1
              ? `<button class="am-returns__button am-returns__button--secondary" data-action="back" type="button">${escapeHtml(
                  t('customer.returns.actions.back')
                )}</button>`
              : ''}
            <button class="am-returns__button" data-action="next" type="button" ${
              !canGoNext || state.submitLoading ? 'disabled' : ''
            }>
              ${
                state.submitLoading
                  ? escapeHtml(t('customer.returns.loading'))
                  : escapeHtml(
                      state.step === 3
                        ? t('customer.returns.actions.confirm')
                        : t('customer.returns.actions.next')
                    )
              }
            </button>
          </div>`
        : ''}
    `;

    if (state.step === 4) {
      root.innerHTML = `
        ${renderProgress()}
        ${renderConfirmation(orderTitleHtmlConfirmation)}
      `;
      bindLineItemImageFallback(root);
      return;
    }

    root.innerHTML = `
      ${
        returnedItemsIntro
          ? `<div class="am-returns__order-summary">${orderTitleHtml}${returnedItemsIntro}</div>`
          : orderTitleHtml
      }
      <div class="am-returns__content-card">${contentHtml}</div>
    `;
    bindLineItemImageFallback(root);
  }

  function renderProgress() {
    return `
      <div class="am-returns__progress">
        ${renderProgressItem(1, t('customer.returns.progress_bar.select'), config.progressIcons.select, 'select')}
        ${renderProgressItem(2, t('customer.returns.progress_bar.reasons'), config.progressIcons.reasons, 'reasons')}
        ${renderProgressItem(4, t('customer.returns.progress_bar.confirmation'), config.progressIcons.confirmation, 'confirmation')}
      </div>
    `;
  }

  function renderProgressItem(step, label, iconUrl, key) {
    const classes = ['am-returns__progress-item'];
    if (state.step >= step) classes.push('is-active');
    if (state.step > step) classes.push('is-done');
    const icon = iconUrl
      ? `<span class="am-returns__progress-icon">
          <img src="${escapeAttr(iconUrl)}" alt="" width="30" height="30" loading="lazy">
        </span>`
      : '';
    return `<div class="${classes.join(' ')}" data-step="${escapeAttr(key)}">
      <span class="am-returns__progress-circle">${icon}</span>
      <span class="am-returns__progress-label">${escapeHtml(label)}</span>
    </div>`;
  }

  function renderReturnedItems() {
    if (!state.returnedItems.length) return '';
    const rows = state.returnedItems
      .map((item) => renderReadonlyItem(item, getReasonLabel(item.returnReasonId)))
      .join('');
    return `
      <div class="am-returns__returned-products">
        <p class="am-returns__returned-products-title">${escapeHtml(t('customer.returns.returned_items.products_label'))}</p>
        ${rows}
      </div>
    `;
  }

  function renderPrintLabelSection() {
    if (!state.returnedItems.length) return '';
    const shippingLabelUrl = getShippingLabelUrl(state.order.shippingCountryCode, state.order.number);
    const showPrintLabel = Boolean(shippingLabelUrl && anyItemHasConsentRequiredReason(state.returnedItems));
    if (!showPrintLabel) return '';
    return `
      <div class="am-returns__print-label-section">
        <h3 class="am-returns__content-title">${escapeHtml(t('customer.returns.print_label_section.title'))}</h3>
        <p class="am-returns__content-copy">${escapeHtml(t('customer.returns.print_label_section.description'))}</p>
        <div class="am-returns__actions am-returns__actions--print-label">
          <a class="am-returns__button am-returns__button--secondary" target="_blank" rel="noopener noreferrer" href="${escapeAttr(
            shippingLabelUrl
          )}">${escapeHtml(t('customer.returns.print_label_section.button'))}</a>
        </div>
      </div>
    `;
  }

  function renderExistingReturnSections() {
    if (!state.returnedItems.length) {
      return '';
    }
    return `
      ${renderPrintLabelSection()}
      ${renderReturnedItems()}
      ${state.items.length ? `<div class="am-returns__content-divider" aria-hidden="true"></div>
      <h3 class="am-returns__section-title">${escapeHtml(t('customer.returns.items_to_return'))}</h3>` : ''}
    `;
  }

  function renderReturnedItemsIntro() {
    if (!state.returnedItems.length) return '';
    return `
      <h3 class="am-returns__section-title">${escapeHtml(t('customer.returns.returned_items.title'))}</h3>
      <p class="am-returns__muted">${escapeHtml(
        t('customer.returns.returned_items.info_returnable', {
          date: state.order && state.order.returnDate ? state.order.returnDate : '',
        })
      )}</p>
    `;
  }

  function renderStepSelection() {
    const standalone = state.items.filter((item) => !item.parent_id);
    const shellsHtml = state.shellItems
      .map((shell) => {
        const children = state.items.filter((item) => item.parent_id === shell.id);
        if (!children.length) return '';
        return `
          <div class="am-returns__item">
            <div class="am-returns__item-head">
              <div class="am-returns__item-main">
                ${lineItemImgHtml(shell.productImage)}
                <div class="am-returns__item-copy">
                  <p class="am-returns__item-title">${escapeHtml(shell.title || '')}</p>
                </div>
              </div>
              <div class="am-returns__item-actions">
                <button class="am-returns__button am-returns__button--secondary" data-action="toggle-shell" data-shell-id="${shell.id}" type="button">Toggle</button>
              </div>
            </div>
            <div data-shell-body="${shell.id}">
              ${children.map((item) => renderSelectableItem(item)).join('')}
            </div>
          </div>
        `;
      })
      .join('');

    return `${standalone.map((item) => renderSelectableItem(item)).join('')}${shellsHtml}`;
  }

  function renderSelectableItem(item) {
    return `
      <div class="am-returns__item">
        <div class="am-returns__item-head">
          <input type="checkbox" ${item.selected ? 'checked' : ''} data-action="toggle-select" data-uuid="${item.uuid}">
          <div class="am-returns__item-main">
            ${lineItemImgHtml(item.productImage)}
            <div class="am-returns__item-copy">
              <p class="am-returns__item-title">${escapeHtml(item.title || '')}</p>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function renderStepReasons(reviewMode) {
    const selected = state.items.filter((item) => item.selected);
    return selected.map((item) => renderReasonItem(item, reviewMode)).join('');
  }

  function renderReturnImageField(item, field, labelHtml, idShort) {
    const id = `amr-${idShort}-${item.uuid}`;
    const errKey = returnImageFieldErrorKey(field);
    const nameKey = returnImageFieldFileNameKey(field);
    const err = item[errKey];
    const data = item[field];
    const fileName = item[nameKey];
    const hint = field === 'consentImage' ? t('customer.returns.product_picture.description') : '';
    const milestoneClass = field === 'consentImage' ? ' am-returns__reason-block--milestone' : '';
    const preview = data
      ? `<img src="${escapeAttr(data)}" width="88" height="88" alt="" loading="lazy">`
      : `<span class="am-returns__upload-tile-placeholder">${escapeHtml(
          fileName ? String(fileName) : t('customer.returns.upload.choose_file')
        )}</span>`;
    return `
      <div class="am-returns__reason-block am-returns__reason-block--upload${milestoneClass}">
        <div class="am-returns__reason-block-title">${labelHtml}</div>
        ${hint ? `<p class="am-returns__reason-block-copy">${escapeHtml(hint)}</p>` : ''}
        <div class="am-returns__upload-field">
          <input
            id="${id}"
            class="am-returns__file-input-native"
            type="file"
            accept="${RETURN_IMAGE_ACCEPT}"
            data-uuid="${escapeAttr(item.uuid)}"
            data-field="${field}"
            autocomplete="off"
          >
          <label class="am-returns__upload-tile" for="${id}">
            ${preview}
          </label>
        </div>
        ${err ? `<p class="am-returns__error am-returns__error--field">${escapeHtml(err)}</p>` : ''}
      </div>
    `;
  }

  function renderReasonItem(item, reviewMode) {
    const reason = findReturnReasonById(item.returnReasonId);
    const showConsent = reason && isConsentRequiredFlag(reason.consent_required);
    const needsReasonError = state.validateStep && !item.returnReasonId;
    const needsPictureError = state.validateStep && showConsent && !item.consentImage;
    const needsMethodError = state.validateStep && showConsent && !item.returnMethod;

    const reasonOptions = state.returnReasons
      .map(
        (entry) =>
          `<option value="${entry.id}" ${entry.id === item.returnReasonId ? 'selected' : ''}>${escapeHtml(
            entry.reason
          )}</option>`
      )
      .join('');

    if (reviewMode) {
      return `
        <div class="am-returns__item am-returns__item--reason-review">
          <div class="am-returns__item-head">
            ${lineItemImgHtml(item.productImage)}
            <div style="flex:1">
              <p class="am-returns__item-title">${escapeHtml(item.title || '')}</p>
              <p class="am-returns__item-sub">${escapeHtml(t('customer.returns.return_reason'))}: ${escapeHtml(
                getReasonLabel(item.returnReasonId)
              )}</p>
            </div>
          </div>
        </div>
      `;
    }

    return `
      <div class="am-returns__item am-returns__item--reason${showConsent ? ' is-expanded' : ''}">
        <div class="am-returns__reason-layout">
          <div class="am-returns__reason-summary">
            ${lineItemImgHtml(item.productImage)}
            <div class="am-returns__reason-summary-copy">
              <p class="am-returns__item-title">${escapeHtml(item.title || '')}</p>
            </div>
          </div>
          <div class="am-returns__reason-content">
            <div class="am-returns__reason-select-wrap">
              <select class="am-returns__reason-select" data-uuid="${item.uuid}" data-field="reason">
                <option value="">${escapeHtml(t('customer.returns.return_reason_placeholder'))}</option>
                ${reasonOptions}
              </select>
              <span class="am-returns__reason-select-arrow slideshow-control slideshow-control--next slideshow-control--style-chevron button button-unstyled button-unstyled--transparent" aria-hidden="true">
                ${config.chevronIcon || ''}
              </span>
            </div>
            ${showConsent ? `
              <div class="am-returns__reason-sections">
              ${renderReturnImageField(
                item,
                'consentImage',
                `${escapeHtml(t('customer.returns.product_picture.title'))} *`,
                'consent'
              )}

              <div class="am-returns__reason-block am-returns__reason-block--milestone">
                <div class="am-returns__reason-block-title">${escapeHtml(t('customer.returns.damaged_parcel.title'))}</div>
                <p class="am-returns__reason-block-copy">${escapeHtml(t('customer.returns.damaged_parcel.damaged_parcel_question'))}</p>
                <div class="am-returns__radios am-returns__radios--reasons">
                  <label><input type="radio" name="damaged-${item.uuid}" value="yes" data-uuid="${item.uuid}" data-field="damagedParcel" ${item.damagedParcel ? 'checked' : ''}> ${escapeHtml(
                  t('customer.returns.damaged_parcel.yes')
                )}</label>
                  <label><input type="radio" name="damaged-${item.uuid}" value="no" data-uuid="${item.uuid}" data-field="damagedParcel" ${item.damagedParcel === false ? 'checked' : ''}> ${escapeHtml(
                  t('customer.returns.damaged_parcel.no')
                )}</label>
                </div>
              </div>

              ${item.damagedParcel ? `
                ${renderReturnImageField(
                  item,
                  'parcelImage',
                  escapeHtml(t('customer.returns.damaged_parcel.parcel_photo')),
                  'parcel'
                )}
                ${renderReturnImageField(
                  item,
                  'labelImage',
                  escapeHtml(t('customer.returns.damaged_parcel.label_photo')),
                  'label'
                )}
              ` : ''}

              <div class="am-returns__reason-block am-returns__reason-block--milestone">
                <div class="am-returns__reason-block-title">${escapeHtml(t('customer.returns.return_method.title'))} *</div>
                <p class="am-returns__reason-block-copy">${escapeHtml(t('customer.returns.return_method.description'))}</p>
                <div class="am-returns__radios am-returns__radios--reasons">
                  <label><input type="radio" name="method-${item.uuid}" value="reshipment" data-uuid="${item.uuid}" data-field="returnMethod" ${
                  item.returnMethod === 'reshipment' ? 'checked' : ''
                }> ${escapeHtml(t('customer.returns.return_method.reshipment'))}</label>
                  <label><input type="radio" name="method-${item.uuid}" value="refund" data-uuid="${item.uuid}" data-field="returnMethod" ${
                  item.returnMethod === 'refund' ? 'checked' : ''
                }> ${escapeHtml(t('customer.returns.return_method.refund'))}</label>
                </div>
              </div>
              </div>
            ` : ''}

            ${
              needsReasonError || needsPictureError || needsMethodError
                ? `<div class="am-returns__error">
                    ${needsReasonError ? `<p>${escapeHtml(t('customer.returns.validation.no_reason'))}</p>` : ''}
                    ${needsPictureError ? `<p>${escapeHtml(t('customer.returns.validation.no_picture'))}</p>` : ''}
                    ${needsMethodError ? `<p>${escapeHtml(t('customer.returns.validation.no_return_method'))}</p>` : ''}
                  </div>`
                : ''
            }
          </div>
        </div>
      </div>
    `;
  }

  function renderReadonlyItem(item, reasonLabel) {
    return `
      <div class="am-returns__item">
        <div class="am-returns__item-head">
          ${lineItemImgHtml(item.productImage)}
          <div style="flex:1">
            <p class="am-returns__item-title">${escapeHtml(item.title || '')}</p>
            <p class="am-returns__item-sub">${escapeHtml(t('customer.returns.return_reason'))}: ${escapeHtml(reasonLabel)}</p>
          </div>
        </div>
      </div>
    `;
  }

  function renderConfirmationPackListItem(item) {
    return `
      <div class="am-returns__confirmation-pack-item">
        ${lineItemImgHtml(item.productImage)}
        <div class="am-returns__confirmation-pack-copy">
          <p class="am-returns__confirmation-pack-title">${escapeHtml(item.title || '')}</p>
          <p class="am-returns__confirmation-pack-reason">${escapeHtml(t('customer.returns.return_reason'))}: ${escapeHtml(
            getReasonLabel(item.returnReasonId)
          )}</p>
        </div>
      </div>
    `;
  }

  function renderConfirmation(orderTitleHtml) {
    const selected = state.items.filter((item) => item.selected);
    const shippingLabelUrl = getShippingLabelUrl(state.order.shippingCountryCode, state.order.number);
    const showPrintLabel = Boolean(shippingLabelUrl);
    const packlistOpen = state.confirmationPacklistOpen;
    const faqHtml = config.faqUrl
      ? `<a class="am-returns__confirmation-faq-link" target="_blank" rel="noopener noreferrer" href="${escapeAttr(
          config.faqUrl
        )}">${escapeHtml(t('customer.returns.confirmation_page.faq_link'))}</a>`
      : escapeHtml(t('customer.returns.confirmation_page.faq_link'));

    return `
      <div class="am-returns__confirmation-card">
        <div class="am-returns__confirmation-summary">
          ${orderTitleHtml}
          <h3 class="am-returns__confirmation-summary-title">${escapeHtml(t('customer.returns.confirmation_page.title'))}</h3>
          <p class="am-returns__confirmation-summary-copy">${escapeHtml(t('customer.returns.confirmation_page.description'))}</p>
        </div>

        <div class="am-returns__confirmation-body">
          <div class="am-returns__confirmation-step">
            <div class="am-returns__confirmation-step-index">1</div>
            <div class="am-returns__confirmation-step-content">
              <h4 class="am-returns__confirmation-step-title">${escapeHtml(t('customer.returns.confirmation_page.print_label_title'))}</h4>
              <p class="am-returns__confirmation-step-copy">${escapeHtml(t('customer.returns.confirmation_page.print_label_copy'))}</p>
              ${
                showPrintLabel
                  ? `<a class="am-returns__button am-returns__button--secondary" target="_blank" rel="noopener noreferrer" href="${escapeAttr(
                      shippingLabelUrl
                    )}">${escapeHtml(t('customer.returns.print_label_section.button'))}</a>`
                  : ''
              }
            </div>
          </div>

          <div class="am-returns__confirmation-step am-returns__confirmation-step--packing">
            <div class="am-returns__confirmation-step-index">2</div>
            <div class="am-returns__confirmation-step-content">
              <h4 class="am-returns__confirmation-step-title">${escapeHtml(t('customer.returns.confirmation_page.pack_items_title'))}</h4>
              <div class="am-returns__confirmation-notice">${escapeHtml(t('customer.returns.confirmation_page.notice'))}</div>
              <div class="am-returns__confirmation-icons">
                ${(function() {
                  const iconItems = [
                    { key: 'packItems',   label: t('customer.returns.confirmation_page.pack_icon_label') },
                    { key: 'attachLabel', label: t('customer.returns.confirmation_page.attach_icon_label') },
                    { key: 'sendOut',     label: t('customer.returns.confirmation_page.send_icon_label') },
                  ];
                  return iconItems.map(({ key, label }) => {
                    const src = confirmationIconUrl(key);
                    return (
                      '<div class="am-returns__confirmation-icon-item">' +
                      (src ? `<img src="${escapeAttr(src)}" alt="" width="80" height="80" loading="lazy">` : '') +
                      `<span>${escapeHtml(label)}</span>` +
                      '</div>'
                    );
                  }).join('');
                })()}
              </div>
            </div>
          </div>

          <div class="am-returns__confirmation-packlist${packlistOpen ? ' is-open' : ''}">
            <button class="am-returns__confirmation-packlist-head" type="button" data-action="toggle-packlist" aria-expanded="${packlistOpen ? 'true' : 'false'}">
              <div>
                <h4 class="am-returns__confirmation-packlist-title">${escapeHtml(
                  t('customer.returns.pack_your_items_section.item_list.title')
                )}</h4>
                <p class="am-returns__confirmation-packlist-copy">${escapeHtml(
                  t('customer.returns.pack_your_items_section.item_list.description')
                )}</p>
              </div>
              <span class="am-returns__confirmation-packlist-arrow slideshow-control slideshow-control--next slideshow-control--style-chevron button button-unstyled button-unstyled--transparent" aria-hidden="true">
                ${config.chevronIcon || ''}
              </span>
            </button>
            ${
              packlistOpen
                ? `<div class="am-returns__confirmation-pack-items">
                    ${selected.map((item) => renderConfirmationPackListItem(item)).join('')}
                  </div>`
                : ''
            }
          </div>

          <div class="am-returns__confirmation-divider" aria-hidden="true"></div>

          <div class="am-returns__confirmation-faq">
            <h4 class="am-returns__confirmation-faq-title">${escapeHtml(t('customer.returns.confirmation_page.faq_title'))}</h4>
            <p class="am-returns__confirmation-faq-copy">${t('customer.returns.confirmation_page.faq_copy', { faq_link: faqHtml })}</p>
          </div>

          <div class="am-returns__confirmation-actions">
            <a class="am-returns__button am-returns__button--secondary" href="/account">${escapeHtml(
              t('customer.returns.actions.my_account')
            )}</a>
          </div>
        </div>
      </div>
    `;
  }

  function syncConfirmationPacklist() {
    const packlist = root.querySelector('.am-returns__confirmation-packlist');
    const toggle = root.querySelector('[data-action="toggle-packlist"]');
    if (!packlist || !toggle) return;

    packlist.classList.toggle('is-open', state.confirmationPacklistOpen);
    toggle.setAttribute('aria-expanded', state.confirmationPacklistOpen ? 'true' : 'false');

    let items = packlist.querySelector('.am-returns__confirmation-pack-items');
    if (state.confirmationPacklistOpen) {
      if (!items) {
        const selected = state.items.filter((item) => item.selected);
        items = document.createElement('div');
        items.className = 'am-returns__confirmation-pack-items';
        items.innerHTML = selected.map((item) => renderConfirmationPackListItem(item)).join('');
        packlist.appendChild(items);
        bindLineItemImageFallback(items);
      }
    } else if (items) {
      items.remove();
    }
  }

  /** API may send booleans or strings; non-boolean truthy strings like "false" must be false. */
  function isConsentRequiredFlag(value) {
    if (value === true || value === 1) return true;
    if (value === false || value === 0 || value == null) return false;
    if (typeof value === 'string') {
      const s = value.trim().toLowerCase();
      if (s === 'true' || s === '1' || s === 'yes') return true;
      if (s === 'false' || s === '0' || s === 'no' || s === '') return false;
    }
    return false;
  }

  function findReturnReasonById(reasonId) {
    if (reasonId == null || reasonId === '') return null;
    const direct = state.returnReasons.find((entry) => entry.id === reasonId);
    if (direct) return direct;
    return state.returnReasons.find((entry) => String(entry.id) === String(reasonId)) || null;
  }

  function getReasonLabel(reasonId) {
    const reason = findReturnReasonById(reasonId);
    return reason ? reason.reason : '';
  }

  function reasonRequiresConsent(reasonId) {
    if (reasonId == null || reasonId === '') return false;
    const reason = findReturnReasonById(reasonId);
    return reason ? isConsentRequiredFlag(reason.consent_required) : false;
  }

  function anyItemHasConsentRequiredReason(items) {
    return items.some((item) => reasonRequiresConsent(item.returnReasonId));
  }

  function normalizeReturnReasons(input) {
    if (Array.isArray(input)) return input;
    if (!input || typeof input !== 'object') return [];
    if (Array.isArray(input.result)) return input.result;
    return Object.values(input).filter(
      (entry) => entry && typeof entry === 'object' && 'id' in entry && 'reason' in entry
    );
  }

  async function getOrderReturnDetails(orderNumber, customerEmail) {
    const url = new URL(location.origin + ENDPOINTS.details);
    url.searchParams.append('shopify_domain', config.shopifyDomain);
    url.searchParams.append('order_number', orderNumber);
    url.searchParams.append('shopify_customer_email', customerEmail);

    const response = await fetchWithAuth(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json().catch(() => null);
    const normalized = data && (data.result || data[0] || data);
    return {
      ok: response.ok,
      status: response.status,
      data: normalized,
      raw: data,
      triedOrder: orderNumber,
    };
  }

  async function getOrderReturnDetailsWithFallback(orderNumbers, customerEmail) {
    let lastResponse = null;
    const triedOrders = [];

    for (const orderNumber of orderNumbers) {
      const response = await getOrderReturnDetails(orderNumber, customerEmail);
      triedOrders.push(orderNumber);
      lastResponse = response;

      if (response.ok) {
        return {
          ...response,
          triedOrders,
        };
      }

      // Keep retrying candidates only for lookup mismatch-style statuses.
      if (![404, 406, 422].includes(response.status)) {
        return {
          ...response,
          triedOrders,
        };
      }
    }

    return {
      ...(lastResponse || { ok: false, status: 422, data: null, raw: null }),
      triedOrders,
    };
  }

  function buildOrderCandidates(input) {
    const value = String(input || '').trim();
    const noHash = value.replace(/^#/, '').trim();
    const withHash = noHash ? `#${noHash}` : '';
    const upper = noHash.toUpperCase();
    const withHashUpper = upper ? `#${upper}` : '';

    // Preserve insertion order and uniqueness.
    return Array.from(new Set([value, noHash, withHash, upper, withHashUpper].filter(Boolean)));
  }

  async function getOrderReturnReasons() {
    const url = new URL(location.origin + ENDPOINTS.reasons);
    url.searchParams.append('shop_domain', config.shopifyDomain);

    const response = await fetchWithAuth(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json().catch(() => []);
    return {
      ok: response.ok,
      status: response.status,
      data,
    };
  }

  async function postOrderReturn({ items, orderId, shopId }) {
    const payload = {
      return: {
        order_id: orderId,
        shop_id: shopId,
        return_lineitems_attributes: {},
      },
    };

    items.forEach((item, index) => {
      const itemPayload = {
        line_item_id: item.id,
        return_reason_id: item.returnReasonId,
        quantity: item.quantity,
        refund: item.returnMethod !== 'reshipment',
        images: [],
      };

      if (item.consentImage) itemPayload.images.push({ data: item.consentImage });
      if (item.parcelImage) itemPayload.images.push({ data: item.parcelImage });
      if (item.labelImage) itemPayload.images.push({ data: item.labelImage });

      payload.return.return_lineitems_attributes[index] = itemPayload;
    });

    const response = await fetchWithAuth(location.origin + ENDPOINTS.returns, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) throw new Error('Return submit failed');
    return response;
  }

  function getShippingLabelUrl(shippingCountryCode, orderNumber) {
    if (!shippingCountryCode || !orderNumber) return '';
    const hash = config.shippingHash[String(shippingCountryCode).toLowerCase()];
    if (!hash) return '';
    return `https://www.dhl.de/retoure/gw/rpcustomerweb/OrderEntry.action?hash=${encodeURIComponent(
      hash
    )}&CustomerReference=${encodeURIComponent(orderNumber)}`;
  }

  function lineItemProductImageUrl(lineItem) {
    if (!lineItem || typeof lineItem !== 'object') return '';
    const img = lineItem.image;
    const fromNested =
      img && typeof img === 'object'
        ? String(img.src || img.url || '').trim()
        : typeof img === 'string'
          ? img.trim()
          : '';
    const candidates = [
      lineItem.image_url,
      lineItem.imageUrl,
      lineItem.variant_image_url,
      lineItem.product_image_url,
      lineItem.thumbnail,
      fromNested,
    ];
    for (let i = 0; i < candidates.length; i += 1) {
      const v = candidates[i];
      if (typeof v === 'string' && v.trim()) return v.trim();
    }
    return '';
  }

  function normalizeLineItemImageUrl(raw) {
    if (!raw || typeof raw !== 'string') return '';
    let url = raw.trim();
    if (!url) return '';
    if (url.startsWith('//')) url = `https:${url}`;
    if (url.startsWith('/') && !url.startsWith('//')) {
      url = `${window.location.origin}${url}`;
    }
    try {
      const u = new URL(url);
      if (u.protocol === 'http:') u.protocol = 'https:';
      const h = u.hostname;
      if (h.includes('shopify') || h.includes('shopifycdn.com')) {
        if (!u.searchParams.has('width')) u.searchParams.set('width', '240');
      }
      return u.toString();
    } catch {
      return url;
    }
  }

function lineItemImgHtml(imageUrl) {
  const src = normalizeLineItemImageUrl(String(imageUrl || '').trim());
  if (!src) {
    return '<span class="am-returns__item-image am-returns__item-image--placeholder" aria-hidden="true"></span>';
  }
  return `<img class="am-returns__item-image" src="${escapeAttr(src)}" alt="" width="77" height="68" loading="lazy" decoding="async">`;
}

function bindLineItemImageFallback(container) {
  if (!container) return;
  container.querySelectorAll('img.am-returns__item-image').forEach((img) => {
    img.addEventListener(
      'error',
      function onLineImgError() {
        img.removeEventListener('error', onLineImgError);
        const ph = document.createElement('span');
        ph.className = 'am-returns__item-image am-returns__item-image--placeholder';
        ph.setAttribute('aria-hidden', 'true');
        img.replaceWith(ph);
      },
      { once: true }
    );
  });
  }

  function prepareOrderReturnResponse({ orderDetails, returnReasons }) {
    const shellItems = [];
    const items = [];
    const returnedItems = [];
    const returnedItemsQuantity = {};
    let returnDate = null;
    const normalizedOrderDetails = orderDetails && typeof orderDetails === 'object' ? orderDetails : {};
    const lineItems = Array.isArray(normalizedOrderDetails.line_items) ? normalizedOrderDetails.line_items : [];
    const returnLineItems = Array.isArray(normalizedOrderDetails.return_lineitems)
      ? normalizedOrderDetails.return_lineitems
      : [];
    const firstReturnReasonId = returnReasons[0] ? returnReasons[0].id : null;

    lineItems.forEach((item) => {
      if (item.parent_id && !shellItems.some((entry) => entry.id === item.parent_id)) {
        shellItems.push({ id: item.parent_id });
      }
    });

    returnLineItems.forEach((item) => {
      const lineItem = lineItems.find((entry) => entry.id === item.line_item_id);
      if (!lineItem) return;

      returnedItems.push({
        ...lineItem,
        productImage: lineItemProductImageUrl(lineItem),
        uuid: createUuid(),
        returnReasonId: item.return_reason_id,
      });
      returnDate = item.created_at;
      returnedItemsQuantity[item.line_item_id] = (returnedItemsQuantity[item.line_item_id] || 0) + item.quantity;
    });

    lineItems.forEach((item) => {
      let isShellItem = false;
      for (let index = 0; index < shellItems.length; index += 1) {
        if (shellItems[index].id === item.id) {
          isShellItem = true;
          shellItems[index] = {
            ...shellItems[index],
            productImage: lineItemProductImageUrl(item),
            title: item.title,
          };
        }
      }
      if (isShellItem) return;

      const returnedQuantity = returnedItemsQuantity[item.id] || 0;
      const maxQuantity = Math.max(0, item.quantity - returnedQuantity);

      for (let index = 0; index < maxQuantity; index += 1) {
        items.push({
          ...item,
          productImage: lineItemProductImageUrl(item),
          uuid: createUuid(),
          selected: false,
          returnReasonId: firstReturnReasonId,
          consentImage: '',
          labelImage: '',
          parcelImage: '',
          returnMethod: '',
          damagedParcel: false,
        });
      }
    });

    const filteredShellItems = shellItems.filter((shellItem) =>
      items.some((item) => shellItem.id === item.parent_id)
    );

    const firstLineItem = lineItems[0] || {};
    const orderId = firstLineItem.order_id || normalizedOrderDetails.order_id || null;
    const shopId =
      (normalizedOrderDetails.shop && normalizedOrderDetails.shop.id) || normalizedOrderDetails.shop_id || null;
    const orderNumber = String(normalizedOrderDetails.shopify_number || '').toUpperCase();

    return {
      items,
      shellItems: filteredShellItems,
      returnedItems,
      returnReasons,
      order: {
        number: orderNumber,
        creationDate: formatDate(firstLineItem.created_at),
        shopId,
        id: orderId,
        customerEmail: normalizedOrderDetails.shopify_customer_email || '',
        shippingCountryCode: normalizedOrderDetails.shipping_country || '',
        returnDate: formatDate(returnDate),
      },
    };
  }

  function formatDate(value) {
    if (!value) return '';
    const date = new Date(value);
    return date.toLocaleDateString();
  }

  function createUuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  function readJsonScript(id, fallback) {
    const el = document.getElementById(id);
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (error) {
      return fallback;
    }
  }

  function resolveAuthToken(localConfig) {
    if (localConfig && localConfig.token) return String(localConfig.token).trim();
    return '';
  }

  async function fetchWithAuth(url, init) {
    const baseHeaders = { ...(init && init.headers ? init.headers : {}) };
    const token = authToken;

    const firstHeaders = token ? { ...baseHeaders, Authorization: token } : { ...baseHeaders };
    let response = await fetch(url, { ...init, headers: firstHeaders });

    if (response.status === 401 && token && !token.toLowerCase().startsWith('bearer ')) {
      const bearerHeaders = { ...baseHeaders, Authorization: `Bearer ${token}` };
      response = await fetch(url, { ...init, headers: bearerHeaders });
    }

    return response;
  }

  function decodeEntities(message) {
    return String(message)
      .replaceAll('&amp;', '&')
      .replaceAll('&lt;', '<')
      .replaceAll('&gt;', '>')
      .replaceAll('&quot;', '"')
      .replaceAll('&#39;', "'");
  }

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
})();
